import BaseApi from './BaseApi';

import {
	DownloadInvestmentAgreementProps,
	IInvestSecondaryMarketProps,
	SaleInvestmentProps,
	DownloadAssigmentAgreementProps,
} from 'models/api';
import { PaginationParams, SortPaginationParams } from 'models';

class MyInvestmentsApi extends BaseApi {
	getCurrent(params: SortPaginationParams) {
		return this.httpClient.get({
			url: '/investor/investments/current-projects',
			config: { params },
			conditions: { version: 'v2', auth: true },
		});
	}

	getFinished(params: SortPaginationParams) {
		return this.httpClient.get({
			url: '/investor/investments/finished-projects',
			config: { params },
			conditions: { version: 'v2', auth: true },
		});
	}

	downloadFinished(params: PaginationParams) {
		return this.httpClient.get({
			url: '/investor/investments/finished-projects/export',
			config: {
				responseType: 'blob',
				params,
			},
			conditions: { version: 'v2', auth: true },
		});
	}

	downloadCurrent(params: PaginationParams) {
		return this.httpClient.get({
			url: '/investor/investments/current-projects/export',
			config: {
				responseType: 'blob',
				params,
			},
			conditions: { version: 'v2', auth: true },
		});
	}

	downloadInvestmentAgreement({ id, lang }: DownloadInvestmentAgreementProps) {
		return this.httpClient.get({
			conditions: { auth: true },
			url: `/investments/${id}/agreement/${lang}`,
			config: {
				responseType: 'blob',
			},
		});
	}

	downloadAssigmentAgreement({ type, investmentId, lang }: DownloadAssigmentAgreementProps) {
		return this.httpClient.get({
			conditions: { auth: true, version: 'v2' },
			url: `/investor/agreements/secondary-market/download/deal/${type}/${investmentId}/${lang}`,
			config: {
				responseType: 'blob',
			},
		});
	}

	getSaleProject({ id }: DownloadInvestmentAgreementProps) {
		return this.httpClient.get({
			url: `/investor/investments/${id}/sale-properties`,
			conditions: { version: 'v2', auth: true },
		});
	}

	saleInvestment({ body, id }: SaleInvestmentProps) {
		return this.httpClient.post({
			url: `/investor/investments/${id}/sale`,
			conditions: { version: 'v2', auth: true },
			body,
		});
	}
	cancelSaleInvestment({ id }: IInvestSecondaryMarketProps) {
		return this.httpClient.patch({
			url: `/investor/investments/sales/${id}/cancel`,
			conditions: { version: 'v2', auth: true },
		});
	}
}

export const MyInvestmentsService = new MyInvestmentsApi();
